import type { Campaign } from './campaignTypes';

// The prospection map tour, the first time a user with the new map opens it
// (once; users who finished the tour another way are skipped). No holdout or
// goal: it introduces the screen rather than nudging a behaviour, and the map
// sends no event yet to measure against.
export const prospectionMapFirstVisit: Campaign = {
  tour: 'prospection-map',
  audience: {
    tenants: 'ra',
    modules: ['prospection_map_v2'],
    recipients: 'everyone',
  },
  priority: 10,
};
